// eslint-disable-next-line no-shadow
export enum ProfilePopOverOptions {
	ACCOUNT = 'account',
	PROFILE = 'profile',
	HISTORY = 'history',
	CREDITS = 'credits',
	API = 'api',
	CONTACT = 'contact',
	LOGOUT = 'logout',
}
